import axios from 'axios';
import { createEffect, createEvent, createStore, forward, guard } from 'effector';
import { toaster } from 'evergreen-ui';

import { config } from 'src/config';
import { LocalStorageKeys } from 'src/common/local-stoage-keys';

export type GetTokenPayload = {
	email: string;
	password: string;
}
export type AuthData = {
	user: string;
	expiresIn: string;
	accessToken: string;
	refreshToken: string;
}

export const getTokenFx = createEffect<GetTokenPayload, AuthData>({
	async handler(data) {
		const url = `${config.baseUrl}/users/token`;
		const res = await axios.post(url, data);
		return res.data;
	},
});
export const logout = createEvent();
export const loadAuthFromLS = createEffect<void, AuthData>({
	handler() {
		const auth = localStorage.getItem(LocalStorageKeys.auth);

		if (!auth) { throw new Error();}

		return JSON.parse(auth);
	},
});
loadAuthFromLS.fail.watch((e) => console.log('fail', e));
export const saveAuthToLS = createEffect<AuthData, void>({
	handler(auth) {
		localStorage.setItem(LocalStorageKeys.auth, JSON.stringify(auth));
	},
});
export const deleteAuthFromLS = createEffect({
	handler: () => {
		localStorage.removeItem(LocalStorageKeys.auth);
	},
});

export const authData$ = createStore<AuthData | null>(null)
	.on(loadAuthFromLS.doneData, (_, data) => data)
	.on(getTokenFx.doneData, (_, data) => data)
	.reset(logout);
getTokenFx.fail.watch((e) => {
	// @ts-ignore
	const code = e.error?.response?.data?.message;
	if (code === 'account_not_active') {
		toaster.danger('To login you need to verify your account');
	} else {
		toaster.danger('Wrong email or password');
	}
});

forward({
	from: logout,
	to: deleteAuthFromLS,
});
guard({
	source: authData$,
	filter: data => data !== null,
	target: saveAuthToLS,
});
